import { API_URL } from '../components/common/Config';

// Global cache for active promotions to prevent multiple API calls across components
let promotionsCache = {
  data: null,
  timestamp: null,
  cacheDuration: 5 * 60 * 1000, // 5 minutes
  loadingPromise: null, // Track ongoing API call to prevent concurrent requests
};

export const getCachedPromotions = async (accessToken) => {
  const now = Date.now();
  
  // Return cached data if it exists and is still valid
  if (promotionsCache.data && promotionsCache.timestamp && (now - promotionsCache.timestamp) < promotionsCache.cacheDuration) {
    return promotionsCache.data;
  }
  
  // If there's already an ongoing API call, wait for it instead of making a new one
  if (promotionsCache.loadingPromise) {
    try {
      return await promotionsCache.loadingPromise;
    } catch (error) {
      // If the ongoing call fails, we'll make a new one
      console.error("Previous promotion fetch failed, retrying:", error);
    }
  }
  
  // Make a new API call
  const fetchPromise = fetch(
    `${API_URL}/api/promotions?status=active&page=1&page_size=1000`,
    {
      method: "GET",
      headers: {
        authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    }
  )
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      if (data.success && data.data && data.data.promotions) {
        // Update cache
        promotionsCache.data = data.data.promotions;
        promotionsCache.timestamp = Date.now();
        promotionsCache.loadingPromise = null;
        return data.data.promotions;
      }
      promotionsCache.loadingPromise = null;
      return [];
    })
    .catch((error) => {
      console.error("Error fetching promotions:", error);
      promotionsCache.loadingPromise = null;
      return [];
    });
  
  // Store the promise so other calls can wait for it
  promotionsCache.loadingPromise = fetchPromise;
  
  return await fetchPromise;
};

export const clearPromotionsCache = () => {
  promotionsCache.data = null;
  promotionsCache.timestamp = null;
  promotionsCache.loadingPromise = null;
};

export const checkProductInActivePromotions = async (productId, accessToken) => {
  try {
    const promotions = await getCachedPromotions(accessToken);
    
    const activePromotions = promotions.filter((promo) => {
      const buyProducts = promo.buy_products || [];
      const getProducts = promo.get_products || [];
      return (
        buyProducts.some((p) => p.product_id == productId) ||
        getProducts.some((p) => p.product_id == productId)
      );
    });

    return {
      hasActivePromotions: activePromotions.length > 0,
      promotions: activePromotions,
    };
  } catch (error) {
    console.error("Error checking product in promotions:", error);
    return { hasActivePromotions: false, promotions: [] };
  }
};

